import { render } from "./PlayerTopBar.vue?vue&type=template&id=076d64e7&scoped=true"
import script from "./PlayerTopBar.vue?vue&type=script&lang=js"
export * from "./PlayerTopBar.vue?vue&type=script&lang=js"

import "./PlayerTopBar.vue?vue&type=style&index=0&id=076d64e7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076d64e7"]])

export default __exports__